import React, { Component } from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import {
  DataGrid,
  Column,
  Pager,
  Paging,
  Lookup,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import { overOrShorReportData } from "../../pages/OverviewReport";
import { selectReasonCodes } from "../../redux/cash-in-out/cash-in-out-selectors";

const format = {
  precision: 2,
  type: "fixedPoint",
};

class TransactionDetailTemplate extends Component {
  constructor(props) {
    super(props);
    this.dataSource = getTasks(props.data.key);
  }

  onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });
  };
  render() {
    return (
      <React.Fragment>
        <div className='master-detail-caption'>Transaction Totals</div>
        <DataGrid
          dataSource={this.dataSource}
          showBorders={true}
          hoverStateEnabled={true}
          cellHintEnabled={true}
          remoteOperations={false}
          showRowLines={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          showColumnLines={true}
          wordWrapEnabled={true}
          columnAutoWidth={true}
          onToolbarPreparing={this.onToolbarPreparingx}
        >
          <Paging defaultPageSize={50} />
          <Pager
            showNavigationButtons={true}
            showPageSizeSelector={true}
            allowedPageSizes={[50, 100, 200]}
            showInfo={true}
          />

          <Column dataField='paymentType.type' caption='Payment Type' />
          <Column dataField='paymentType.cardType' caption='Card Type' />
          <Column dataField='varianceReasonID' caption='Reason Code'>
            <Lookup
              dataSource={this.props.reasonCodes}
              valueExpr='reasonID'
              displayExpr='name'
            />
          </Column>
          <Column dataField='counted' />
          <Column dataField='income' format={format} />
          <Column dataField='expected' format={format} />
          <Column dataField='initialAmount' format={format} />
          <Column dataField='overShortAmount' format={format} />
          <Column dataField='totalCashInAndOut' format={format} />
          <Summary recalculateWhileEditing={true} texts={{ sum: "{0}" }}>
            <TotalItem column='income' summaryType='sum' valueFormat={format} />
            <TotalItem
              column='expected'
              summaryType='sum'
              valueFormat={format}
            />
            <TotalItem
              column='initialAmount'
              summaryType='sum'
              valueFormat={format}
            />
            <TotalItem
              column='overShortAmount'
              summaryType='sum'
              valueFormat={format}
            />
            <TotalItem
              column='totalCashInAndOut'
              summaryType='sum'
              valueFormat={format}
            />
          </Summary>
        </DataGrid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  reasonCodes: selectReasonCodes,
});

export default connect(mapStateToProps, {})(TransactionDetailTemplate);

function getTasks(key) {
  const data = overOrShorReportData.find((report) => report.id === key);
  let transactions = [];
  if (data && data.transactionTotals.length) {
    transactions = data.transactionTotals.map((trans, index) => ({
      ...trans,
      id: index + 1,
    }));
  }

  return new DataSource({
    store: new ArrayStore({
      data: transactions,
      key: "id",
    }),
  });
}
